interface TitlePageType {
  title: string;
  subtitle: string;
}

export const TitlePage = (props: TitlePageType) => {
  return (
    <div>
      <div className='flex h-auto items-center max-md:block'>
        <div className='h-[1px] w-[140px] bg-[#272727] max-md:hidden' />
        <p className='ml-6 h-[107px] text-center font-[Prata] text-[56px] leading-[107px] whitespace-nowrap text-[#272727] max-md:m-0 max-md:h-auto max-md:text-[28px] max-md:leading-[28px]'>
          {props.title}
        </p>
      </div>
      <p className='mt-5 ml-[163px] h-[87px] w-[329px] text-left text-lg font-light text-[#4c4c4c] max-md:m-0 max-md:h-auto max-md:w-full max-md:p-4 max-md:text-center max-md:text-lg max-md:text-[#4c4c4c80]'>
        {props.subtitle}
      </p>
    </div>
  );
};
